import * as React from 'react';

import moment from 'moment';

import {ModalBody} from 'shells/typography/modal-body';

import type {CampaignType} from 'nutshell-graphql-types';
import type {EditionFragment as Edition} from 'nutshell-graphql-types';

import {PreviewBody} from './preview-body';

type Props = {
    edition: Edition;
    scheduledDate: moment.Moment | null | undefined;
    type: CampaignType;
};

export function PreviewView(props: Props) {
    return (
        <div className='full-width'>
            <ModalBody>
                {getModalTitle(props, props.type)}
                {'. '}
                {props.scheduledDate
                    ? 'Sending dates and times can be updated or cancelled before the message is sent.'
                    : 'This cannot be undone, so double check that everything looks correct before proceeding.'}
            </ModalBody>
            <PreviewBody
                edition={props.edition}
                scheduledDate={props.scheduledDate}
                type={props.type}
            />
        </div>
    );
}

function getModalTitle(props: Props, type: CampaignType): string {
    const userFacingNoun = type === 'NEWSLETTER' ? 'edition' : 'broadcast';
    const audienceCount = props.edition.audience
        ? props.edition.audience.membershipStats.totalCount.value
        : undefined;

    // You’re about to schedule this edition for sending to 100 recipients
    if (props.scheduledDate) {
        return `You’re about to schedule this ${userFacingNoun}
    ${
        audienceCount
            ? ` for sending to ${audienceCount.toLocaleString()} ${
                  audienceCount > 1 ? 'recipients' : 'recipient'
              }`
            : ''
    }`;
    }

    // You’re about to send this edition to 100 recipients
    return `You’re about to send this ${userFacingNoun}
    ${
        audienceCount
            ? ` to ${audienceCount.toLocaleString()} ${
                  audienceCount > 1 ? 'recipients' : 'recipient'
              }`
            : ''
    }`;
}
